export default function SecondaryHeading (props) {

  const {
    children,
    border = false,
    className = '',
    width = 'w-full',
  } = props

  const classNames = [
    'text-xl font-medium',
    width,
    className,
    border ? 'border-b pb-2 mb-6' : ''
  ]

  return (
    <h2 className={classNames.join(' ')}>
      {children}
    </h2>
  )
}
